export const CHART_HEIGHT = 340;
